import './index.css'
import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_LINE_HEIGHT,
} from '@disco/constants/content-editor'
import { getMaxImageWidth } from '@disco/content-editor/editor-utils'
import { changeRichText } from '@disco/state-management/actions/campaign-editor-actions'
import { sanitize } from '@disco/utils/string-utils'
import * as React from 'react'
import { connect } from 'react-redux'
import type { Campaign, CampaignSection } from 'types/content-editor'
import { emailColors } from '@disco/utils/colors'
import RichTextEditor from 'components/common/rich-text-editor'
type Props = {
  content: Record<string, any> | null | undefined
  htmlContent: string
  editMode?: boolean
  sectionIndex: number
  columnIndex: number
  contentIndex: number
  changeRichText: typeof changeRichText
  section?: CampaignSection
  campaign?: Campaign
}

class TextBlock extends React.Component<Props> {
  _editor: HTMLElement | null | undefined

  /*
  componentDidUpdate(prevProps: Props) {
    if (this.props.editMode && !prevProps.editMode && this._editor) {
      // calling focus here causes links to not to be shown in editor,
      // needs investigation
      this._editor.focus()
    }
  }
  */
  render() {
    const {
      content,
      htmlContent,
      editMode,
      sectionIndex,
      columnIndex,
      contentIndex,
      changeRichText,
      section,
      campaign,
    } = this.props
    const maxImageWidth = getMaxImageWidth(section, campaign)
    const lineHeight =
      section?.lineHeight || campaign?.lineHeight || DEFAULT_LINE_HEIGHT
    const fontFamily =
      section?.fontFamily || campaign?.fontFamily || DEFAULT_FONT_FAMILY

    if (editMode) {
      return (
        <div
          className="content-editor__formatting-block__column__text-block"
          style={{
            lineHeight,
            fontFamily,
          }}
        >
          <RichTextEditor
            initialContent={content}
            showToolbar
            colors={emailColors}
            type="email"
            maxImageWidth={maxImageWidth}
            onChange={(contentObject, html) =>
              changeRichText(
                sectionIndex,
                columnIndex,
                contentIndex,
                contentObject,
                html,
              )
            }
            editorRef={r => {
              this._editor = r
            }}
          />
        </div>
      )
    }

    return (
      <div
        className="content-editor__formatting-block__column__text-block"
        // eslint-disable-next-line react/no-danger -- markup goes through sanitize() (DOMPurify)
        dangerouslySetInnerHTML={{
          __html: sanitize(htmlContent) || '&nbsp;',
        }}
        style={{
          lineHeight,
          fontFamily,
        }}
      />
    )
  }
}

export default connect(null, {
  changeRichText,
})(TextBlock) as any
